import {Box} from '@mui/material';
import './styles/CollaborateurPublicView.css';

const Banner = () => <Box className="banner"/>;
export default Banner;